import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { motion, AnimatePresence } from "framer-motion";

// Animation variants for the page container
const pageVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.2,
      ease: [0.25, 0.1, 0.25, 1.0], // cubic-bezier easing for smooth motion
    },
  },
  exit: {
    opacity: 0,
    y: 15,
    transition: {
      duration: 0.3,
    },
  },
};

// Animation variants for the card
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.98,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 80,
      damping: 15,
      mass: 1,
      when: "beforeChildren",
      staggerChildren: 0.07,
    },
  },
};

// Animation variants for the card content
const contentVariants = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 15,
    },
  },
};

// Animation variants for the title and description
const textVariants = {
  hidden: {
    opacity: 0,
    x: -5,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 10,
      duration: 0.1,
      mass: 0.5,
    },
  },
};

export const PageLayout: React.FC<{
  title: any;
  description?: any;
  children: React.ReactNode;
  extraRight?: React.ReactNode;
}> = ({ title, description, children, extraRight }) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div variants={pageVariants} initial="hidden" animate="visible" exit="exit" className="space-y-6 w-full">
        <motion.div variants={cardVariants}>
          <Card className="overflow-hidden rounded-none">
            <CardHeader className="pb-3 bg-gradient-to-r from-primary/5 to-background">
              <div className="flex items-center justify-between">
                <motion.div variants={textVariants}>
                  <CardTitle className="text-2xl font-bold flex items-center gap-2">{title}</CardTitle>
                  {description && <CardDescription className="mt-1.5">{description}</CardDescription>}
                </motion.div>
                {extraRight && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2, duration: 0.3 }}
                  >
                    {extraRight}
                  </motion.div>
                )}
              </div>
            </CardHeader>
            <CardContent className="pt-4">
              <motion.div
                variants={contentVariants}
                className="rounded-md overflow-hidden"
                // style={{
                //   boxShadow: "0 4px 15px rgba(0, 0, 0, 0.03)",
                //   transformOrigin: "top center",
                // }}
              >
                {children}
              </motion.div>
            </CardContent>
          </Card>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
